const initialSate = {
    call_queues: [],
    isReadingCallQueues: false,
    isCreatingCallQueues: false,
    count: 0
}

export default initialSate;
